import { create } from "zustand";

interface StoreLocatorIntentState {
  stacklineSku: string | null;
  requestId: number;
  request: (stacklineSku: string) => void;
  clear: () => void;
}

export const useStoreLocatorIntent = create<StoreLocatorIntentState>((set) => ({
  stacklineSku: null,
  requestId: 0,
  request: (stacklineSku: string) =>
    set((state) => ({
      stacklineSku,
      requestId: state.requestId + 1,
    })),
  clear: () => set({ stacklineSku: null }),
}));
